import React from "react";
import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import numeral from "numeral";
import { removeMinus } from "../../../libs/utils";

const ReconciliationDeadlineBlock = ({
  key,
  deadline,
  totalAmount,
  counterpartName,
  date,
  description,
  linkedTo,
  onClick,
  selectedDeadlines,
  openDeadlineDetail,
  showDetail,
  canSelect
}) => {
  const formattedDate = moment(date).format("DD MMM YYYY");
  const formattedAmount = removeMinus(totalAmount);

  return (
    <div
      onClick={() => (canSelect ? onClick(deadline.id) : {})}
      className={
        "dbx-reconciliation-deadlines-block-container" +
        (selectedDeadlines.indexOf(deadline.id) > -1 ? " selected" : "")
      }
      key={key}
    >
      <div className="dbx-reconciliation-deadlines-block-amount">
        <div
          className={
            "dbx-reconciliation-movement-card-amount-deadline" +
            (totalAmount < 0 ? " amountMinus" : " amountPlus")
          }
        >
          <FontAwesomeIcon
            icon={["fas", totalAmount < 0 ? "minus-circle" : "plus-circle"]}
          />{" "}
          {numeral(formattedAmount).format("0,0.00") + " €"}
        </div>
      </div>
      <div className="dbx-reconciliation-deadlines-block-info">
        <p className="dbx-reconciliation-deadlines-block-date">
          <FormattedMessage id="reconciliation.deadlines.deadlineDate" values={{
            movementType: totalAmount < 0 ? "pagare" : "incassare"
          }}/>{" "}
          {formattedDate}
        </p>
        <p className="dbx-reconciliation-deadlines-block-counterpartName">
          {" "}
          {counterpartName}
        </p>
        <div className="dbx-reconciliation-deadlines-block-description">
          {description}
          <div
            className="dbx-reconciliation-deadlines-block-icons"
            style={{ justifyContent: !linkedTo && "flex-end" }}
          >
            {/* linkedTo &&
							<FontAwesomeIcon
								icon={["far", "unlink"]}
								style={{
									color: "rgb(0, 144, 209)",
									cursor: "pointer",
									fontSize: "16px"
								}}
							// onClick={}
						/>*/}

            {showDetail !== false && (
              <FontAwesomeIcon
                icon={["far", "eye"]}
                style={{
                  color: "var(--brand-primary)",
                  cursor: "pointer",
                  fontSize: "16px"
                }}
                onClick={e => {
                  e.stopPropagation();
                  openDeadlineDetail(deadline.id);
                }}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReconciliationDeadlineBlock;
